/**
 * Booth queue links: /queue/<booth code> and /queue/<booth code>/<event slug>.
 *
 * Mirrors server/utils/inviteLink.js so the link previewed on the booth form is exactly the
 * one the server saves. Codes are lowercase letters, numbers and single dashes, with no "?",
 * "=" or "%" for email, Word or a phone to mangle.
 */

const MAX_CODE_LENGTH = 60;
const INVISIBLE_CHARS = /[​-‍⁠﻿­]/g;
const DASH_LIKE = /[‐-―−⁃﹘﹣－_.\s]+/g;

export const normalizeInviteCode = (raw) => {
  if (raw === null || raw === undefined) return '';
  return String(raw)
    .normalize('NFKD')
    .replace(/[̀-ͯ]/g, '')
    .toLowerCase()
    .replace(INVISIBLE_CHARS, '')
    .replace(DASH_LIKE, '-')
    .replace(/[^a-z0-9-]/g, '')
    .replace(/-+/g, '-')
    .replace(/^-+|-+$/g, '')
    .slice(0, MAX_CODE_LENGTH)
    .replace(/-+$/g, '');
};

/** The booth's link: /queue/<code>. Works for every event the booth is in. */
export const buildBoothQueueUrl = (baseUrl, boothCode) => `${baseUrl}/queue/${boothCode}`;

/** The booth's test link: /queue/<code>/test/<test code>. Ignores the booth's open, close and expiry times. */
export const buildBoothTestQueueUrl = (baseUrl, boothCode, testCode) =>
  `${buildBoothQueueUrl(baseUrl, boothCode)}/test/${testCode}`;

/** A link for one of the booth's events: /queue/<code>/<event slug>. */
export const buildEventQueueUrl = (baseUrl, boothCode, eventSlug) => {
  const eventCode = normalizeInviteCode(eventSlug);
  return eventCode
    ? `${buildBoothQueueUrl(baseUrl, boothCode)}/${eventCode}`
    : buildBoothQueueUrl(baseUrl, boothCode);
};
